import React from 'react';
import { styled } from '@mui/material/styles';
import { Backdrop, Box, Button, Typography, Fade, Divider } from '@mui/material';
import { X as Close, AlertCircle } from 'react-feather';
import PropTypes from 'prop-types';

const PREFIX = 'AreYouSureModal';

const classes = {
  root: `${PREFIX}-root`,
  backdropBox: `${PREFIX}-backdropBox`,
  title: `${PREFIX}-title`,
  message: `${PREFIX}-message`,
  buttonBox: `${PREFIX}-buttonBox`,
  cancelBtn: `${PREFIX}-cancelBtn`,
  deleteBtn: `${PREFIX}-deleteBtn`,
  closeIcon: `${PREFIX}-closeIcon`,
};

const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  [`& .${classes.root}`]: {
    zIndex: theme.zIndex.modal + 1,
    color: theme.palette.text.primary,
  },

  [`& .${classes.backdropBox}`]: {
    position: 'relative',
    backgroundColor: '#EFF0F2',
    padding: theme.spacing(3),
    borderRadius: theme.shape.borderRadius,
    width: 500,
    textAlign: 'left',
  },

  [`& .${classes.title}`]: {
    color: theme.palette.text.primary,
    marginLeft: theme.spacing(1),
  },

  [`& .${classes.message}`]: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(2),
  },

  [`& .${classes.buttonBox}`]: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginTop: theme.spacing(3),
  },

  [`& .${classes.cancelBtn}`]: {
    textTransform: 'capitalize',
    marginRight: theme.spacing(1),
    '&:hover': {
      backgroundColor: theme.palette.grey[300],
    },
  },

  [`& .${classes.deleteBtn}`]: {
    textTransform: 'capitalize',
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: theme.palette.error.dark,
    },
  },

  [`& .${classes.closeIcon}`]: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    cursor: 'pointer',
    width: 20,
  },
}));

AreYouSureModal.propTypes = {
  isOpen: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.string,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
};

export default function AreYouSureModal({ isOpen, title, message, onConfirm, onCancel }) {
  if (!isOpen) {
    return null;
  }

  return (
    <StyledBackdrop aria-hidden="false" open={isOpen} style={{ zIndex: 9999 }}>
      <Fade in={isOpen}>
        <Box className={classes.backdropBox}>
          <Close className={classes.closeIcon} onClick={onCancel} />
          <Box display="flex" justifyContent="flex-start" alignItems="center" marginBottom="10px">
            <AlertCircle color="#EC942C" />
            <Typography variant="h6" className={classes.title}>
              {title}
            </Typography>
          </Box>
          <Divider />
          <Typography variant="body1" className={classes.message}>
            {message}
          </Typography>
          <Box className={classes.buttonBox}>
            <Button variant="outlined" className={classes.cancelBtn} onClick={onCancel}>
              Cancel
            </Button>
            <Button variant="contained" className={classes.deleteBtn} onClick={onConfirm}>
              Delete
            </Button>
          </Box>
        </Box>
      </Fade>
    </StyledBackdrop>
  );
}
